"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListRow = void 0;
var classNames = require("classnames");
var React = require("react");
var SokReducerTypes = require("@caddigital/sok-reducers/lib/types");
var sok_ui_1 = require("@caddigital/sok-ui");
var components_1 = require("components");
var Utils = require("../../utils");
var createRowCell = function (item) { return function (column) {
    var _a, _b;
    var key = column.prop.toLowerCase();
    var value = item[column.prop];
    var width = (_a = column.pixelWidth) !== null && _a !== void 0 ? _a : 0;
    return (React.createElement("div", { key: key, "data-key": "__".concat(key), "data-length": (_b = value === null || value === void 0 ? void 0 : value.length) !== null && _b !== void 0 ? _b : 0, className: classNames('row__column', key), style: Utils.createCellStyle(width) },
        React.createElement("div", null, value)));
}; };
var StatusIcons = {
    COMPLETED: 'fa-check',
    IN_PROGRESS: 'fa-spinner fa-spin',
    FAILED: 'fa-times'
};
var createRowIcons = function (_a) {
    var listEntryType = _a.listEntryType, isDownloadable = _a.isDownloadable, isSelected = _a.isSelected, status = _a.status, onDownloadButtonClick = _a.onDownloadButtonClick, onInfoButtonClick = _a.onInfoButtonClick, onToggleSelect = _a.onToggleSelect;
    var classes = ['row__column', 'narrow'];
    var statusIcon = StatusIcons[status];
    var statusIconClass = "status-icon-".concat(typeof status === 'string' ? status.toLowerCase() : String());
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classNames.apply(void 0, classes) },
            React.createElement(components_1.TableRowIcon, { className: isSelected ? 'selected' : null, circle: true, icon: 'fa-check', onClick: onToggleSelect })),
        React.createElement("div", { className: classNames.apply(void 0, classes) },
            React.createElement(components_1.TableRowIcon, { circle: true, icon: listEntryType === SokReducerTypes.TEMPLATE ? 'fa-pencil' : 'fa-info', onClick: onInfoButtonClick })),
        listEntryType === SokReducerTypes.REPORT && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classNames.apply(void 0, classes) },
                React.createElement(sok_ui_1.Icon, { className: classNames('sok-icon-download-cloud', !isDownloadable && 'disabled'), onClick: isDownloadable ? onDownloadButtonClick : undefined })),
            React.createElement("div", { className: classNames.apply(void 0, __spreadArray(__spreadArray([], classes, false), [statusIconClass], false)) },
                React.createElement(components_1.TableRowIcon, { square: true, icon: statusIcon }))))));
};
var component = function (_a) {
    var index = _a.index, data = _a.data, style = _a.style;
    var columns = data.columns, items = data.items, selectedUuids = data.selectedUuids, listEntryType = data.listEntryType, isReportFileFetching = data.isReportFileFetching, onDownloadButtonClick = data.onDownloadButtonClick, onInfoButtonClick = data.onInfoButtonClick, onSelectionChange = data.onSelectionChange;
    var item = items[index];
    var isSelected = selectedUuids.includes(item.uuid);
    var createCell = createRowCell(item);
    var icons = createRowIcons({
        listEntryType: listEntryType,
        isDownloadable: !isReportFileFetching && item.status === 'COMPLETED',
        isSelected: isSelected,
        status: item.status,
        onDownloadButtonClick: function () { return onDownloadButtonClick(item.uuid, item.name); },
        onInfoButtonClick: function () {
            return onInfoButtonClick(item.uuid, {
                mode: listEntryType === SokReducerTypes.TEMPLATE ? 'EDIT' : 'VIEW',
                type: listEntryType
            });
        },
        onToggleSelect: function () {
            return onSelectionChange(isSelected
                ? selectedUuids.filter(function (selectedUuid) { return selectedUuid !== item.uuid; })
                : __spreadArray(__spreadArray([], selectedUuids, true), [item.uuid], false));
        }
    });
    return (React.createElement("div", { className: 'row', style: style },
        icons,
        columns.map(createCell)));
};
exports.ListRow = React.memo(component);
